<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/PMAlertSummary'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <!-- <label class="label">From date :</label> -->
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="rePmaDateStart"
                      name="rePmaDateStart"
                      ref="rePmaDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <!-- <label class="label">To date:</label> -->
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="rePmaDateEnd"
                      name="rePmaDateEnd"
                      ref="rePmaDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    v-model="reDepartments"
                    @selectChange="onDepartmentChange"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    v-model="reAgentCodes"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportPMAlertSummary"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="MonthlyTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="9">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">ตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">
                      จำนวนครั้งในการแจ้งเตือนการ PM
                    </th>
                    <th class="all text-center">
                      แจ้งเตือนเข้า PM ครั้งล่าสุด
                    </th>
                    <th class="all text-center">
                      จำนวนครั้งในการแจ้งเตือนการเปลี่ยนอะไหล่
                    </th>
                    <th class="all text-center">
                      แจ้งเตือนเปลี่ยนอะไหล่ครั้งล่าสุด
                    </th>
                  </tr>
                </thead>
                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reAaDateReq: null,
      reMonthCode: null,
      reAgentCodes: null,
      reUserId: null,
      reIsInitial: true,
      reDepartments: null,
      rePmaDateStart: null,
      rePmaDateEnd: null,
      reAgentCodesOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartments,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reDepartmentsOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Users/Select2User",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reMonthOptions: {
        placeholder: "กรุณาเลือก เดือน",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/PM/PMMonthlyOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reMonthCode = null;
      self.reAgentCodes = null;
      self.reUserId = null;
      self.reDepartments = null;
      self.rePmaDateStart = null;
      self.rePmaDateEnd = null;

      $("#rePmaDateStart")
        .val("")
        .trigger("change");

      $("#rePmaDateEnd")
        .val("")
        .trigger("change");

      $("#reMonthCode")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reUserId")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      e.preventDefault();
      var table = $("#MonthlyTable").DataTable();
      table.draw();
    },
    exportPMAlertSummary: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportPMAlertSummary",
        responseType: "arraybuffer",
        data: {
          IsInitial: false,
          SalesArea: self.reDepartments,
          Agentcode: self.reAgentCodes,
          StartDate:
            self.rePmaDateStart != null
              ? self.rePmaDateStart.format("DD/MM/YYYY")
              : null,
          EndDate:
            self.rePmaDateEnd != null
              ? self.rePmaDateEnd.format("DD/MM/YYYY")
              : null,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    onDepartmentChange() {
      this.reAgentCodes = null;

      $("#reAgentCodes")
        .val("")
        .trigger("change");
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.rePmaDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //minDate: moment(), // Current day
      //maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateStart = moment().set("date",1);
    $(self.$refs.rePmaDateStart)
      .datepicker(
        "update",
        !!self.rePmaDateStart ? self.rePmaDateStart.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.rePmaDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.rePmaDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //minDate: moment(), // Current day
      //maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateStart = moment().set("date",1);
    $(self.$refs.rePmaDateEnd)
      .datepicker(
        "update",
        !!self.rePmaDateEnd ? self.rePmaDateEnd.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.rePmaDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MonthlyTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PMAlertSummary",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reIsInitial,
              SalesArea: self.reDepartments,
              Agentcode: self.reAgentCodes,
              StartDate:
                self.rePmaDateStart != null
                  ? self.rePmaDateStart.format("DD/MM/YYYY")
                  : null,
              EndDate:
                self.rePmaDateEnd != null
                  ? self.rePmaDateEnd.format("DD/MM/YYYY")
                  : null,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[7, "desc"]],
        columns: [
          {
            data: "department",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "salesAreaName", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          {
            data: "totalAlert",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "0";
              } else {
                return data;
              }
            },
          },
          {
            data: "latestDateAlertString",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === "") {
                return "-";
              } else {
                return data;
              }
            },
          },
          {
            data: "totalChangeAlert",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === null) {
                return "0";
              } else {
                return data;
              }
            },
          },
          {
            data: "latestDateChangeAlertString",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === "") {
                return "-";
              } else {
                return data;
              }
            },
          },
        ],
        drawCallback: function(settings) {
          self.reIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reMonthCode: "required",
      },
      messages: {
        reMonthCode: "กรุณาเลือกเดือน",
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PMAlertSummary.vue